<template>
  <!-- <section class="hero">
    <nav
      class="breadcrumb"
      aria-label="breadcrumbs"
      style="margin-bottom: auto; margin-inline-start: 1em"
    >
      <ul>
        <li>
          <router-link :to="{ name: 'AdminHome' }">{{
            $t("Home")
          }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ReportsTransition' }">{{
            $t("Reports")
          }}</router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">{{ $t(this.name) }}</a>
        </li>
      </ul>
    </nav>

  </section>
  <hr
    style="
      width: 30%;
      border-width: medium;
      border-style: groove;
      margin: 0.5em 0;
    "
  /> -->
  <div>
    <div class="small-section">
      <div class="columns">
        <div class="column is-one-third">
          <div class="box has-light-shadow-border">
            <div class="field is-vertical">
              <years-select
                v-model="year"
                :from="new Date().getFullYear() - 100"
                :label="true"
                :isRemoveAllYear="true"
                @input="clearData"
              ></years-select>
            </div>
          </div>

          <div class="field is-grouped" style="margin-inline-start: 1em;flex-wrap: wrap; gap:10px;">
            <div class="control alignmentFix">
              <button
                :class="[
                  { 'is-loading': loading },
                  'button',
                  'is-medium',
                  'is-focused',
                  'is-info',
                ]"
                v-shortkey.once="['enter']"
                @shortkey="loadData()"
                @click="loadData"
              >
                {{ $t("Refresh") }}
              </button>
            </div>
            <div class="control">
            <button
              :class="['button', 'is-medium', 'is-focused', 'is-info']"
              @click="print('pdf')"
            >
              {{ $t("Print (PDF)") }}
            </button>
          </div>
          <div class="control">
            <button
              :class="['button', 'is-medium', 'is-focused', 'is-info']"
              @click="print('jpg')"
            >
              {{ $t("Download (JPG)") }}
            </button>
          </div>
          </div>
        </div>

        <div class="column">
          <nav class="tabs is-boxed option-headers" style="margin-bottom: 0">
            <ul>
              <li class="is-active">
                <a>{{ $t("Main Results") }}</a>
              </li>
            </ul>
          </nav>
          <div
            style="margin: 5px"
            class="tile Chart"
            v-show="headerSelector == 0"
          >
            <div class="card tile is-child">
              <div class="card-content">
                <chart
                  style="background-color: white; width: 100%"
                  ref="chart_1"
                  id="chart_1"
                  :extra="extra"
                  :type="type"
                  :data="dataCollection"
                  :bar_options="dataCollectionOptions"
                  :disableClick="true"
                ></chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import randomColor from "randomcolor";
import { defineAsyncComponent } from "vue";
import * as htmlToImage from "html-to-image";
const Chart = defineAsyncComponent(() => import("../controls/Chart.vue"));
// const sharedUtilities = () => import('../sharedUtilities')
const YearsSelect = defineAsyncComponent(() =>
  import("../controls/YearsSelect.vue")
);
import { useToast } from "vue-toastification";
import map from "lodash/map";
import range from "lodash/range";

import {
  initDataCollection,
  initDataOptions,
  printImages,
} from "../reports/reportUtil.js";

export default {
  setup() {
    const toast = useToast();
    return { toast }; // Make it available inside methods
  },
  props: {
    name: { type: String, default: "Pollution Per Crop" },
    superId: null,
  },
  data() {
    return {
      extra: "%",
      pollutant: null,
      nfrId: null,
      pollutantCategory: null,
      city: null,
      CityId: -1,
      department: null,
      values: [],
      percentages: [],
      viewby: false,
      year: new Date().getYear() + 1900,
      type: "bar",
      unit: "",
      All_data: [],
      sectorIds: [],
      dataActive: null,
      governmentIds: [],
      dataCollection: initDataCollection(),
      dataCollectionOptions: initDataOptions(
        this.$t("Governorate"),
        this.$t("Percentage"),
        this.clickHandler
      ),
      loading: false,
      headerSelector: 0,
    };
  },
  computed: {
    years() {
      let currentYear = new Date().getYear() + 1900;
      let years = map(range(currentYear, currentYear - 5, -1), (year) => ({
        year: year,
        display: year,
      }));
      //years.unshift({ year: -1, display: "All" });
      return years;
    },
  },
  watch: {
    pollutant: function () {
      if (this.pollutant != null) {
        //console.log("FE EH",this.pollutant.category);
        this.pollutantCategory = this.pollutant.category;
      } else {
        this.pollutantCategory = "Air";
      }
    },
    city: function (newcity, oldcity) {
      if (this.city != null) {
        if (oldcity != null && oldcity.id != newcity.id) {
          this.department = null;
        }
        this.CityId = this.city.id;
      } else {
        this.CityId = -1;
        this.department = null;
      }
    },
    superId: function () {
      this.loadData();
    },
    viewby: function () {
      //console.log(this.viewby);
      this.changeDataset();
    },
  },
  methods: {
    clickHandler(evt, element) {
      if (element[0] != undefined) {
        this.loading = true;
        this.loadData(1);
      }
    },
    clearData() {
      this.dataCollection = initDataCollection();
      this.headerSelector = 0;
    },

    print(format = "pdf") {
      var images = [];
      if (this.$refs.chart_2 == undefined) {
        //console.log(this.$refs.chart_1)
        images = [this.$refs.chart_1.print()];
      } else {
        images = [this.$refs.chart_1.print(), this.$refs.chart_2.print()];
      }
      if (format == "pdf") {
        printImages(
          this.$t("Test"),
          this.pollutant.name,
          images,
          this.$t("Egyptian Environmental Affairs Agency"),
          this.year,
          this.department,
          this.city,
          this.pollutant
        );
      } else if (format == "jpg") {
        this.printImagesAsJPG(this.name, this.pollutant.name, images);
      }
    },
    printImagesAsJPG(title, subtitle, images) {
      const div = document.createElement("div");
      Object.assign(div.style, {
        backgroundColor: "white",
        padding: "20px",
        zIndex: "-999",
      });

      const add = (Tag, html, styles = {}) => {
        const el = document.createElement(Tag);
        el.innerHTML = html;
        Object.assign(el.style, styles);
        div.appendChild(el);
        return el;
      };
      if (title)
        add("h1", this.$t(title), {
          textAlign: "center",
          color: "#5e9ca0",
          fontSize: "30px",
        });
      if (subtitle)
        add("h2", subtitle, {
          textAlign: "center",
          color: "#5e9ca0",
          fontSize: "25px",
          marginTop: "10px",
        });

      [
        { label: "Year", value: this.year },
        { label: "Department", value: this.department?.Department },
        { label: "City", value: this.city && this.$t(this.city.name) },
        { label: "Pollutant", value: this.pollutant?.name },
      ].forEach(({ label, value }) => {
        if (value != null) {
          add("p", `${this.$t(label)}: ${value}`, {
            fontSize: "20px",
            margin: "5px 0",
          });
        }
      });

      images.forEach((src) => {
        add("img", "", {
          width: "100%",
          marginTop: "20px",
          borderRadius: "10px",
        }).src = src;
      });
      document.body.appendChild(div);
      setTimeout(() => {
        htmlToImage
          .toPng(div, {
            quality: 0.95,
          })
          .then(function (dataUrl) {
            var link = document.createElement("a");
            link.download = title + ".jpg";
            link.href = dataUrl;
            link.click();
          })
          .finally(() => {
            document.body.removeChild(div);
          });
      }, 1000);
    },
    print(format = "pdf") {
      var images = [];
      if (this.$refs.chart_2 == undefined) {
        //console.log(this.$refs.chart_1)
        images = [this.$refs.chart_1.print()];
      } else {
        images = [this.$refs.chart_1.print(), this.$refs.chart_2.print()];
      }
      if (format == "pdf") {
        this.printImages(this.name, this.pollutant.name, images);
      } else if (format == "jpg") {
        this.printImagesAsJPG(this.name, this.pollutant.name, images);
      }
    },
    // show a dialogue wether to print as pdf or jpg
    showPrintDialogue() {
      this.$fire({
        title: this.$t("Print"),
        text: this.$t("Choose File Format"),
        showCancelButton: true,
        confirmButtonText: this.$t("PDF"),
        cancelButtonText: this.$t("Image"),
        // button colors
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#C09300",
      })
        .then((result) => {
          if (result.value === true) {
            this.print();
          } else if (result.dismiss === "cancel") {
            console.log("JPG");
            this.print("jpg");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeDataset() {
      this.dataCollectionOptions.scales.y.title.text = this.$t("ton/year");
      this.dataCollectionOptions2.title.text = this.$t("ton/year");
    },
    loadData() {
      axios
        .post("/report/SWEfficiency", {
          dYear: this.year,
        })
        .then((response) => {
          if (!response.data.Data) {
            this.loading = false;
            this.$alert(this.$t("No data available"));
            return;
          }

          const jsonData = response.data.Data;

          const ids = jsonData.map((item) => item.result_id);

          const jsonLabels = jsonData.map((item) => item.result_type);
          const jsonDataArr = jsonData.map((item) => item.value);

          var datasetCollection = initDataCollection();
          datasetCollection.labels = jsonLabels;
          datasetCollection.datasets[0].data = jsonDataArr;
          datasetCollection.datasets[0].backgroundColor = this.$datasetColor;
          this.dataCollection = datasetCollection;
          this.governmentIds = ids;
          this.loading = false;
          this.dataActive = true;
        });
    },
  },
  components: {
    chart: Chart,
    "years-select": YearsSelect,
  },
};
</script>

<style>
.chart-container {
  height: 100%;
  width: 100%;
}
</style>
